/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientCategory from './patient-category';
import PatientCategoryDetail from './patient-category-detail';
import PatientCategoryUpdate from './patient-category-update';
import PatientCategoryDeleteDialog from './patient-category-delete-dialog';

const PatientCategoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientCategory />} />
    <Route path="new" element={<PatientCategoryUpdate />} />
    <Route path=":id">
      <Route index element={<PatientCategoryDetail />} />
      <Route path="edit" element={<PatientCategoryUpdate />} />
      <Route path="delete" element={<PatientCategoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientCategoryRoutes;
